
export default {
  name: 'AppVideo',
  props: {
    src: { type: String, default: null },
    autoplay: { type: Boolean, default: false },
    controls: { type: Boolean, default: false }
  }
};
